import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
import Content from "./Content";
// import useStyles from "./styles";

const useStyles = makeStyles((theme) => ({
  strong: {
    fontSize: "18px",
    fontWeight: "bold",
    fontStretch: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
  text: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
  a: {
    textDecoration: "none"
  }
}));

export default function TermsAndConditions() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Content>
      <>
        <strong className={classes.strong}>{t("termsandconditions.general")}</strong>
        <p className={classes.text}>{t("termsandconditions.general_paragraph_one")}</p>
        <p className={classes.text}>{t("termsandconditions.general_paragraph_two")}</p>
        <p className={classes.text}>{t("termsandconditions.general_paragraph_three")}</p>
        <p className={classes.text}>{t("termsandconditions.general_paragraph_four")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.privacy")}</strong>
        <p className={classes.text}>{t("termsandconditions.privacy_paragraph_one")}</p>
        <p className={classes.text}>{t("termsandconditions.privacy_paragraph_two")}</p>
        <p className={classes.text}>{t("termsandconditions.privacy_paragraph_three")}</p>
        <p className={classes.text}>{t("termsandconditions.privacy_paragraph_four")}</p>
      </>

      <>
        <strong className={classes.strong}>{t("termsandconditions.data_name")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_name_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_birth")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_birth_info")}</p>
      </>
      <>
        <a className={classes.a} id="parent"><strong className={classes.strong}>{t("termsandconditions.data_parents")}</strong></a>
        <p className={classes.text}>{t("termsandconditions.data_parents_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_region")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_region_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_email")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_email_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_password")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_password_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_groupName")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_groupName_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_votes")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_votes_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_favorite")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_favorite_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_comments")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_comments_info")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_session")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_session_paragraph_one")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("termsandconditions.data_gdpr")}</strong>
        <p className={classes.text}>{t("termsandconditions.data_gdpr_info")}</p>
      </>
    </Content>
  );
}
